/**
 * @generated SignedSource<<566e5b8e2da603e826a4c8f99bc8f058>>
 * @relayHash cf81de6bf2b8920fa9973832fb0303fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d763298e1c12d618ce1a7c9518d4649cbdf1e494a4e98eb46e489434ff4b62c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueChangeInput = {
  issueId: string;
};
export type JiraIssueSearchStaticViewInput = {
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchViewContextInput = {
  expandedGroups?: JiraIssueExpandedGroups | null | undefined;
  expandedParents?: ReadonlyArray<JiraIssueExpandedParent> | null | undefined;
  topLevelItemsLoaded?: number | null | undefined;
};
export type JiraIssueExpandedGroups = {
  groupedByFieldId: string;
  groups?: ReadonlyArray<JiraIssueExpandedGroup> | null | undefined;
};
export type JiraIssueExpandedGroup = {
  fieldValue?: string | null | undefined;
  first?: number | null | undefined;
  jql: string;
};
export type JiraIssueExpandedParent = {
  first?: number | null | undefined;
  parentIssueId: string;
};
export type realtimeIssueDetails_Query$variables = {
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  isDensityFull: boolean;
  isHierarchyEnabled: boolean;
  isInlineEditingEnabled: boolean;
  issueAris: ReadonlyArray<string>;
  issueChanges: ReadonlyArray<JiraIssueChangeInput>;
  issueSearchInput: JiraIssueSearchInput;
  projectKey: string;
  searchViewContextInput: JiraIssueSearchViewContextInput;
  staticViewInput: JiraIssueSearchStaticViewInput;
};
export type realtimeIssueDetails_Query$data = {
  readonly jira: {
    readonly searchViewContexts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly contexts: ReadonlyArray<{
            readonly afterIssueId: string | null | undefined;
            readonly beforeIssueId: string | null | undefined;
            readonly position: number;
            readonly sourceIssueId: string;
          }> | null | undefined;
          readonly jql?: string | null | undefined;
          readonly parentIssueId?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira_issuesByIds: ReadonlyArray<{
    readonly __id: string;
    readonly canHaveChildIssues?: boolean | null | undefined;
    readonly fieldSetsById: {
      readonly __id: string;
      readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets">;
    } | null | undefined;
    readonly issueId: string;
    readonly issueTypeField?: {
      readonly id: string;
      readonly issueType: {
        readonly hierarchy: {
          readonly level: number | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly parentIssueField: {
      readonly parentIssue: {
        readonly __id: string;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"progressSummary_issueViewChildIssuesPanel_statusAndResolved">;
  } | null | undefined> | null | undefined;
};
export type realtimeIssueDetails_Query = {
  response: realtimeIssueDetails_Query$data;
  variables: realtimeIssueDetails_Query$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": isIssueViewChildIssuesPanelRealtimeUpdateEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isIssueViewChildIssuesPanelRealtimeUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-view-child-issues-panel-realtime-update.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDensityFull"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHierarchyEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInlineEditingEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueAris"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueChanges"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchViewContextInput"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v11 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "issueAris"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v13 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v14 = [
  {
    "kind": "Variable",
    "name": "fieldSetIds",
    "variableName": "fieldSetIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "key"
},
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v18 = {
  "args": [
    {
      "kind": "Variable",
      "name": "projectKey",
      "variableName": "projectKey"
    }
  ],
  "kind": "ScalarField",
  "name": "canHaveChildIssues"
},
v19 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "issueChanges",
    "variableName": "issueChanges"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "searchViewContextInput",
    "variableName": "searchViewContextInput"
  },
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "parentIssueId"
    }
  ],
  "type": "JiraIssueSearchBulkViewParentContexts"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    }
  ],
  "type": "JiraIssueSearchBulkViewGroupContexts"
},
v22 = {
  "kind": "ScalarField",
  "name": "sourceIssueId"
},
v23 = {
  "kind": "ScalarField",
  "name": "position"
},
v24 = {
  "kind": "ScalarField",
  "name": "beforeIssueId"
},
v25 = {
  "kind": "ScalarField",
  "name": "afterIssueId"
},
v26 = {
  "kind": "ScalarField",
  "name": "type"
},
v27 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v28 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v29 = {
  "kind": "ScalarField",
  "name": "name"
},
v30 = {
  "kind": "ScalarField",
  "name": "value"
},
v31 = [
  (v30/*: any*/),
  (v16/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v32 = {
  "condition": "isInlineEditingEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lazyIsEditableInIssueView"
        }
      ]
    }
  ]
},
v33 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v34 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v35 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v36 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v37 = {
  "kind": "ScalarField",
  "name": "text"
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v37/*: any*/),
    (v29/*: any*/),
    (v32/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v39 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v40 = [
  (v39/*: any*/)
],
v41 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v16/*: any*/)
  ]
},
v42 = [
  (v41/*: any*/)
],
v43 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v44 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v45 = {
  "kind": "ScalarField",
  "name": "picture"
},
v46 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v47 = [
  (v29/*: any*/),
  (v16/*: any*/)
],
v48 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v50 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v49/*: any*/),
    (v16/*: any*/)
  ]
},
v51 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v16/*: any*/)
  ]
},
v52 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v16/*: any*/)
  ]
},
v53 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v54 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v53/*: any*/),
        (v29/*: any*/),
        (v16/*: any*/)
      ]
    },
    (v16/*: any*/)
  ]
},
v55 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v56 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v50/*: any*/),
    (v16/*: any*/)
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "number"
},
v58 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "formatStyle"
        },
        {
          "kind": "ScalarField",
          "name": "formatUnit"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "name": "realtimeIssueDetails_Query",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "jira_issuesByIds",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          {
            "concreteType": "JiraParentIssueField",
            "kind": "LinkedField",
            "name": "parentIssueField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                  (v13/*: any*/)
                ]
              }
            ]
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                  },
                  {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
              },
              (v13/*: any*/)
            ]
          },
          (v15/*: any*/),
          {
            "condition": "isHierarchyEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/)
                    ]
                  }
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "progressSummary_issueViewChildIssuesPanel_statusAndResolved"
          },
          (v13/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v19/*: any*/),
            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
            "kind": "LinkedField",
            "name": "searchViewContexts",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchBulkViewContextMapping",
                        "kind": "LinkedField",
                        "name": "contexts",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v22/*: any*/),
                            "action": "THROW",
                            "path": "jira.searchViewContexts.edges.node.contexts.sourceIssueId"
                          },
                          {
                            "kind": "RequiredField",
                            "field": (v23/*: any*/),
                            "action": "THROW",
                            "path": "jira.searchViewContexts.edges.node.contexts.position"
                          },
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "realtimeIssueDetails_Query",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "jira_issuesByIds",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          {
            "concreteType": "JiraParentIssueField",
            "kind": "LinkedField",
            "name": "parentIssueField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v13/*: any*/)
                ]
              },
              (v16/*: any*/)
            ]
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "fieldSetId"
                      },
                      {
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v26/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueField"
                                  },
                                  (v16/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraAffectedServiceConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedAffectedServicesConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraAffectedServiceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraAffectedService",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "serviceId"
                                                  },
                                                  (v29/*: any*/),
                                                  (v16/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraAffectedServicesField"
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "parentOptionValue",
                                                "plural": false,
                                                "selections": (v31/*: any*/)
                                              },
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "childOptionValue",
                                                "plural": false,
                                                "selections": (v31/*: any*/)
                                              }
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraCascadingSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "args": (v33/*: any*/),
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraComponentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponent",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v34/*: any*/),
                                                      (v35/*: any*/),
                                                      (v16/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraComponentsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v36/*: any*/),
                                          (v29/*: any*/),
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraDateTimePickerField"
                                      },
                                      (v38/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraCommentSummary",
                                            "kind": "LinkedField",
                                            "name": "commentSummary",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "canAddComment"
                                              },
                                              (v39/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraCommentSummaryField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraUrlField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldOptions",
                                            "plural": false,
                                            "selections": (v40/*: any*/)
                                          },
                                          {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "fieldOption",
                                            "plural": false,
                                            "selections": [
                                              (v30/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": (v42/*: any*/)
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": (v42/*: any*/)
                                              },
                                              (v16/*: any*/),
                                              (v43/*: any*/)
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraSingleSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      (v30/*: any*/),
                                                      (v43/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraMultipleSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      (v30/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraCheckboxesField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraUserConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedUsersConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraUserEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v27/*: any*/),
                                                      (v44/*: any*/),
                                                      (v29/*: any*/),
                                                      (v45/*: any*/),
                                                      (v16/*: any*/),
                                                      (v46/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "email"
                                                          }
                                                        ],
                                                        "type": "AtlassianAccountUser"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraMultipleSelectUserPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraTeamView",
                                            "kind": "LinkedField",
                                            "name": "selectedTeam",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "jiraSuppliedId"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "jiraSuppliedName"
                                              }
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraTeamViewField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraTimeTrackingField",
                                                "kind": "LinkedField",
                                                "name": "timeTrackingField",
                                                "plural": false,
                                                "selections": [
                                                  (v16/*: any*/),
                                                  (v32/*: any*/),
                                                  {
                                                    "concreteType": "JiraEstimate",
                                                    "kind": "LinkedField",
                                                    "name": "originalEstimate",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "timeInSeconds"
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraTimeTrackingSettings",
                                                    "kind": "LinkedField",
                                                    "name": "timeTrackingSettings",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "workingHoursPerDay"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "workingDaysPerWeek"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "defaultFormat"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "defaultUnit"
                                                      }
                                                    ]
                                                  },
                                                  (v28/*: any*/),
                                                  (v29/*: any*/),
                                                  (v26/*: any*/)
                                                ]
                                              },
                                              (v16/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraOriginalTimeEstimateField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "selectedOption",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": "label",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              },
                                              (v16/*: any*/),
                                              (v34/*: any*/)
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraRadioSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "args": (v33/*: any*/),
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedVersionsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      (v29/*: any*/),
                                                      (v34/*: any*/),
                                                      (v35/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "versionId"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraMultipleVersionPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/)
                                            ]
                                          },
                                          {
                                            "args": (v33/*: any*/),
                                            "concreteType": "JiraGoalConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGoals",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraGoalEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGoal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      (v15/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": "selectedGoals(first:1000)"
                                          },
                                          (v32/*: any*/),
                                          (v13/*: any*/)
                                        ],
                                        "type": "JiraGoalsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "args": (v33/*: any*/),
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "href"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v39/*: any*/)
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraConfluenceRemoteIssueLinksField"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraCmdbObjectConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedCmdbObjectsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraCmdbObjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraCmdbObject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "objectId"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                  },
                                                  {
                                                    "concreteType": "JiraCmdbAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraCmdbMediaClientConfig",
                                                        "kind": "LinkedField",
                                                        "name": "mediaClientConfig",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "clientId"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "mediaBaseUrl"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "mediaJwtToken"
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "url48"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "message"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraCMDBField"
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": "componentsOld",
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraComponentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponent",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v47/*: any*/)
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraComponentsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v37/*: any*/)
                                        ],
                                        "type": "JiraSingleLineTextField"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "date"
                                      },
                                      (v29/*: any*/),
                                      (v48/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "type": "JiraDatePickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v36/*: any*/)
                                    ],
                                    "type": "JiraDateTimePickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraEpic",
                                        "kind": "LinkedField",
                                        "name": "epic",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "color"
                                          },
                                          (v16/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraEpicLinkField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "renderedFieldHtml"
                                      }
                                    ],
                                    "type": "JiraFallbackField"
                                  },
                                  (v38/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v49/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraStatusCategoryField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "statusId"
                                          },
                                          (v50/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraStatusField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "args": (v33/*: any*/),
                                        "concreteType": "JiraLabelConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedLabelsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraLabelEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraLabel",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v29/*: any*/),
                                                  (v41/*: any*/)
                                                ]
                                              }
                                            ]
                                          },
                                          (v39/*: any*/)
                                        ],
                                        "storageKey": "selectedLabelsConnection(first:1000)"
                                      },
                                      (v29/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "type": "JiraLabelsField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "small"
                                              }
                                            ]
                                          },
                                          (v29/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraIssueTypeField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "parentIssue",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          (v51/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v52/*: any*/),
                                              (v54/*: any*/),
                                              (v51/*: any*/),
                                              (v16/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v52/*: any*/),
                                              (v54/*: any*/),
                                              (v51/*: any*/),
                                              (v16/*: any*/),
                                              (v12/*: any*/),
                                              (v55/*: any*/),
                                              {
                                                "args": [
                                                  {
                                                    "kind": "Literal",
                                                    "name": "ids",
                                                    "value": [
                                                      "summary",
                                                      "issuetype",
                                                      "status"
                                                    ]
                                                  }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v27/*: any*/),
                                                          (v16/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v28/*: any*/),
                                                              (v37/*: any*/)
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v28/*: any*/),
                                                              {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                  },
                                                                  (v29/*: any*/),
                                                                  (v53/*: any*/),
                                                                  (v17/*: any*/),
                                                                  (v16/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraIssueTypeField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v28/*: any*/),
                                                              (v56/*: any*/)
                                                            ],
                                                            "type": "JiraStatusField"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                              }
                                            ]
                                          },
                                          (v29/*: any*/),
                                          (v32/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraParentIssueField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "iconUrl"
                                          },
                                          (v16/*: any*/)
                                        ]
                                      },
                                      (v29/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "type": "JiraPriorityField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v15/*: any*/),
                                          {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "large"
                                              }
                                            ]
                                          },
                                          (v16/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraProjectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraResolution",
                                        "kind": "LinkedField",
                                        "name": "resolution",
                                        "plural": false,
                                        "selections": (v47/*: any*/)
                                      }
                                    ],
                                    "type": "JiraResolutionField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraSprintConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedSprintsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraSprintEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprint",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v16/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "sprintId"
                                                  },
                                                  (v29/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "state"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "endDate"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v29/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "type": "JiraSprintField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v44/*: any*/),
                                          (v45/*: any*/),
                                          (v29/*: any*/),
                                          (v16/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      },
                                      (v29/*: any*/),
                                      (v48/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "type": "JiraSingleSelectUserPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v29/*: any*/),
                                      {
                                        "args": (v33/*: any*/),
                                        "concreteType": "JiraVersionConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedVersionsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v47/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "selectedVersionsConnection(first:1000)"
                                      }
                                    ],
                                    "type": "JiraMultipleVersionPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraRichText",
                                        "kind": "LinkedField",
                                        "name": "richText",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "adfValue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "condition": "isDensityFull",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                    "kind": "LinkedField",
                                                    "name": "convertedPlainText",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "plainText"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "condition": "isDensityFull",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraRichTextField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraServiceManagementRequestType",
                                        "kind": "LinkedField",
                                        "name": "requestType",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v53/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraServiceManagementRequestTypeField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                          }
                                        ],
                                        "concreteType": "JiraIssueLinkConnection",
                                        "kind": "LinkedField",
                                        "name": "issueLinkConnection",
                                        "plural": false,
                                        "selections": [
                                          (v39/*: any*/),
                                          {
                                            "concreteType": "JiraIssueLinkEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueLink",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v55/*: any*/),
                                                      (v15/*: any*/),
                                                      {
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                              "statusCategory"
                                                            ]
                                                          }
                                                        ],
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v27/*: any*/),
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v50/*: any*/)
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                  },
                                                                  (v16/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                      },
                                                      (v16/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "relationName"
                                                  },
                                                  (v16/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "issueLinkConnection(first:1)"
                                      }
                                    ],
                                    "type": "JiraIssueLinkField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isStoryPointField"
                                      },
                                      (v57/*: any*/),
                                      (v29/*: any*/),
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          (v57/*: any*/),
                                          (v58/*: any*/)
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          (v57/*: any*/),
                                          (v29/*: any*/),
                                          (v32/*: any*/),
                                          (v58/*: any*/)
                                        ]
                                      },
                                      (v32/*: any*/)
                                    ],
                                    "type": "JiraNumberField"
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "concreteType": "JiraGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGroupsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraGroupEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      (v29/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "groupId"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraMultipleGroupPickerField"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraFlag",
                                            "kind": "LinkedField",
                                            "name": "flag",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "isFlagged"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraFlagField"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraWatch",
                                            "kind": "LinkedField",
                                            "name": "watch",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "count"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "isWatching"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraWatchesField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": (v40/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v13/*: any*/)
            ]
          },
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "condition": "isHierarchyEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v16/*: any*/)
                    ]
                  }
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isResolved"
              },
              {
                "concreteType": "JiraStatusField",
                "kind": "LinkedField",
                "name": "statusField",
                "plural": false,
                "selections": [
                  (v56/*: any*/),
                  (v16/*: any*/)
                ]
              }
            ]
          },
          (v13/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v19/*: any*/),
            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
            "kind": "LinkedField",
            "name": "searchViewContexts",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchBulkViewContextMapping",
                        "kind": "LinkedField",
                        "name": "contexts",
                        "plural": true,
                        "selections": [
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0d763298e1c12d618ce1a7c9518d4649cbdf1e494a4e98eb46e489434ff4b62c",
    "metadata": {},
    "name": "realtimeIssueDetails_Query",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": isIssueViewChildIssuesPanelRealtimeUpdateEnabled_provider
    }
  }
};
})();

(node as any).hash = "06ffec7b827cbc5cdf9caab380574530";

export default node;
